import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import _ from 'lodash';
import uuid from 'react-uuid';
import { ucwords, numberWithCommas } from 'helper';
import BusinessActivityCreateModal from './BusinessActivityCreateModal';
import BusinessActivityUpdateModal from './BusinessActivityUpdateModal';
import * as c from '../constant';
import * as actions from '../actions';

function BusinessActivityList({
  businessId,
  getBusinessActivityList,
  businessActivityList,
  removeBusinessActivity,

  createBusinessActivity,
  updateBusinessActivity,

  pathName,
  type,
  activityList,
}) {
  const [viewForm, setViewForm] = useState(false);
  const [viewUpdateForm, setViewUpdateForm] = useState(false);
  const [formData, setFormData] = useState('');
  const [detailFormData, setDetailFormData] = useState({});
  const [formDataQuantityMatrix, setFormDataQuantityMatrix] = useState({});
  const checkIfForRenewal = pathName.indexOf('/bpls/applications/renewal') > -1;

  useEffect(() => {
    getBusinessActivityList(businessId, () => {
      setViewForm(false);
      setViewUpdateForm(false);
    });
  }, [businessId]);

  const handleAddBusinessActivity = (e) => {
    e.preventDefault();
    setViewForm(true);
    setViewUpdateForm(false);
  };

  const handleUpdateBusinessActivity = (id, data) => (e) => {
    e.preventDefault();
    setViewUpdateForm(true, setFormData(data));
    setViewForm(false);
  };

  const closeModal = () => {
    setViewForm(false);
  };

  const closeUpdateModal = () => {
    setViewUpdateForm(false);
  };

  const handleRemoveBusinessActivity = (id, data) => (e) => {
    e.preventDefault();

    ConfirmAlert(
      'Are you sure you want to remove this business activity?',
      () => {
        removeBusinessActivity(id, data.id, () => {
          getBusinessActivityList(id);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const handleOnCreate = (data) => (e) => {
    e.preventDefault();

    const businessNecessary = {
      ...detailFormData,
      quantity_matrix: formDataQuantityMatrix,
    };

    ConfirmAlert(
      'Are you sure you want to add this business activity?',
      () => {
        const args = {
          business_nature_id: _.get(data, 'business_nature_id') || 0,
          business_line_id: _.get(data, 'business_line_id') || 0,
          capital_amount: _.get(data, 'capital_amount') || 0,
          gross_amount: _.get(data, 'gross_amount') || 0,
          industrial_code: _.get(data, 'industrial_code') || 0,
          details: businessNecessary || {},
        };
        createBusinessActivity(businessId, args, () => {
          getBusinessActivityList(businessId);
          setViewForm(false);
          setDetailFormData({});
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const handleOnUpdate = (data) => (e) => {
    e.preventDefault();
    const businessActivityId = _.get(formData, 'id');
    const businessNecessary = {
      ...detailFormData,
      quantity_matrix: formDataQuantityMatrix,
    };

    ConfirmAlert(
      'Are you sure you want to add this business activity?',
      () => {
        const args = {
          business_nature_id: _.get(data, 'business_nature_id'),
          business_line_id: _.get(data, 'business_line_id'),
          capital_amount: _.get(data, 'capital_amount').replace(/,/g, ''),
          gross_amount: _.get(data, 'gross_amount').replace(/,/g, ''),
          industrial_code: _.get(data, 'industrial_code') || 0,
          details: businessNecessary || {},
        };

        updateBusinessActivity(businessId, businessActivityId, args, () => {
          setViewUpdateForm(false);
          getBusinessActivityList(businessId);
          setDetailFormData({});
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  return (
    <div className="p-2">
      {viewForm && (
        <BusinessActivityCreateModal
          businessId={businessId}
          closeModal={closeModal}
          handleOnCreate={handleOnCreate}
          detailFormData={detailFormData}
          setDetailFormData={setDetailFormData}
          formDataQuantityMatrix={formDataQuantityMatrix}
          setFormDataQuantityMatrix={setFormDataQuantityMatrix}
        />
      )}
      {viewUpdateForm && (
        <BusinessActivityUpdateModal
          businessId={businessId}
          closeUpdateModal={closeUpdateModal}
          businessActivityInfo={formData}
          handleOnUpdate={handleOnUpdate}
          detailFormData={detailFormData}
          setDetailFormData={setDetailFormData}
          formDataQuantityMatrix={formDataQuantityMatrix}
          setFormDataQuantityMatrix={setFormDataQuantityMatrix}
        />
      )}
      <div className='border rounded-lg mb-3'>
        <table className="table table-sm table-borderless mb-0">
          <thead>
            <tr className="border-bottom text-primary text-center">
              <th
                width="230"
                className="border-right"
              >
                Line of Business
              </th>
              <th width="170" className="border-right">
                Philippine Standard Industrial Code
              </th>
              <th
                width="400"
                className="border-right"
              >
                Details
              </th>
              <th
                width="250"
                className="border-right"
              >
                {checkIfForRenewal ? 'Gross Amount' : 'Total Capitalization (Ph)'}
              </th>
              {type !== 'VIEW' && (
                <th
                  width="150"
                  className=""
                />
              )}
            </tr>
          </thead>
          <tbody>
            {type !== 'VIEW' &&
              businessActivityList.map(item => {
                const details = _.get(item, 'attributes.details');
                const { quantity_matrix, quantity_matrix_details, ...detail } = details;

                return (
                  <React.Fragment key={item.id}>
                    <tr className=''>
                      <td className='border-right'>
                        {_.get(item, 'attributes.name') || '-'}
                      </td>
                      <td className='border-right'>
                        {_.get(item, 'attributes.industrial_code') || '-'}
                      </td>
                      <td className='border-right'>
                        <div>
                          {detail ?
                            Object.entries(detail).map(x => {
                              return (
                                <div key={uuid()}>
                                  {ucwords(
                                      x[0].replace(/_/g, ' ') || null
                                    )} : {x[1] || null}
                                </div>
                              )}) || '-'
                            : ''}
                        </div>
                        <div>
                          {!_.isEmpty(quantity_matrix) ? (
                            Object.entries(quantity_matrix).map(([label, data]) => {

                              return (
                                <React.Fragment>
                                  <div key={uuid()} className='text-capitalize'>
                                    {label || ''}{' '}:
                                  </div>
                                  <div className='p-1'>
                                    <div className='w-100 border rounded-lg mb-2'>
                                      <table className="table table-borderless table-sm table-striped table-hover mb-0">
                                        <thead>
                                          <tr className='form-group'>
                                            <td className='col-4 form-label text-center border-right'>Unit</td>
                                            <td className='col-4 form-label text-center border-right'>Capacity</td>
                                            <td className='col-4 form-label text-center'>Number of Units</td>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {data.map((x) => {
                                            return (
                                              // eslint-disable-next-line react/no-array-index-key
                                              <tr key={uuid()} className="top-border form-group">
                                                <td className="col-4 text-left form-label border-right">
                                                  {_.get(x, 'unit')} 
                                                </td>
                                                <td className="col-4 text-left form-label border-right">
                                                  {_.get(x, 'capacity')}
                                                </td>
                                                <td className="col-4 text-left form-label">
                                                  {numberWithCommas(x.value) || 0}
                                                </td>
                                              </tr>
                                            );
                                          })
                                        }
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </React.Fragment>
                              )
                            })
                          ) : (
                            ''
                          )}
                        </div>
                      </td>
                      <td className='border-right'>
                        {
                          _.get(
                            item,
                            `attributes.${
                              checkIfForRenewal
                                ? 'gross_amount_human'
                                : 'capital_amount_human'
                            }`
                          ) || '-'
                        }
                      </td>
                      <td className="text-center">
                        <div className="d-flex justify-content-center align-items center my-2">
                          <button
                            onClick={handleUpdateBusinessActivity(
                              businessId,
                              item
                            )}
                            type="button"
                            className="btn-blank btn-sm"
                          >
                            <i className="far fa-edit icon-edit" />
                          </button>
                          <button
                            type="button"
                            className="btn-blank btn-sm"
                            onClick={handleRemoveBusinessActivity(
                              businessId,
                              item
                            )}
                          >
                            <i className="far fa-trash-alt icon-delete" />
                          </button>
                        </div>
                      </td>
                    </tr>
                  </React.Fragment>
                );
              })}
            {type === 'VIEW' &&
              activityList.map((item) => {
                return (
                  <tr key={uuid()}>
                    <td>
                      <input
                        type="text"
                        readOnly
                        className="custom-input my-2"
                        value={_.get(item, 'attributes.name') || '-'}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        readOnly
                        className="custom-input my-2"
                        value={_.get(item, 'attributes.industrial_code') || '-'}
                      />
                    </td>
                    <td>
                      {_.get(item, 'attributes.details')
                        ? Object.entries(_.get(item, 'attributes.details')).map(
                            x => {
                              return (
                                <input
                                  key={uuid()}
                                  type="text"
                                  readOnly
                                  className="custom-input my-2 text-uppercase"
                                  value={`${ucwords(
                                    x[0].replace(/_/g, ' ') || null
                                  )}: ${x[1] || null}`}
                                />
                              );
                            }
                          ) || '-'
                        : ''}
                    </td>
                    <td>
                      <input
                        type="text"
                        readOnly
                        className="custom-input my-2"
                        value={_.get(item, 'attributes.capital_amount') || '-'}
                      />
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>

      </div>
      {type !== 'VIEW' && (
        <div>
          <button
            type="button"
            className="btn btn-primary cms-bg-color-primary cms-outline-primary"
            onClick={handleAddBusinessActivity}
          >
            Add Business Activity
          </button>
        </div>
      )}
    </div>
  );
}

BusinessActivityList.defaultProps = {
  type: '',
  activityList: [],
};

BusinessActivityList.propTypes = {
  businessId: PropTypes.string.isRequired,
  getBusinessActivityList: PropTypes.instanceOf(Function).isRequired,
  businessActivityList: PropTypes.instanceOf(Array).isRequired,
  removeBusinessActivity: PropTypes.instanceOf(Function).isRequired,
  createBusinessActivity: PropTypes.instanceOf(Function).isRequired,
  updateBusinessActivity: PropTypes.instanceOf(Function).isRequired,
  type: PropTypes.string,
  activityList: PropTypes.instanceOf(Array),
  pathName: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }) => ({
  businessActivityList:
    _.get(api, `${c.GET_BUSINESS_ACTIVITY_LIST}.list`) || [],
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(BusinessActivityList);
